import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { subscribeNetworkElement } from '@api/networkElements';

import { INetworkElementsSubscribeDTO } from '@interfaces/networkElements/dto/networkElements';
import { INetworkElement } from '@interfaces/networkElements/networkElements';

import { ESnackbarTypes } from '@enums/common';

import { NETWORK_ELEMENTS_SUBSCRIBE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

import useInvalidateNetworkElements from './useInvalidateNetworkElements';

interface IUseMutateNetworkElementsSubscribeReturned {
	subscribeNetworkElement: (dto: INetworkElementsSubscribeDTO) => void;
	isLoadingSubscribeNetworkElement: boolean;
}

const {
	subscribeNetworkElement: subscribeNetworkElementMessage,
	unsubscribeNetworkElement,
} = responseMessages;

const useMutateNetworkElementsSubscribe = (
	handleCloseModal: () => void,
): IUseMutateNetworkElementsSubscribeReturned => {
	const dispatch = useAppDispatch();
	const invalidateNetworkElements = useInvalidateNetworkElements();

	const {
		isLoading,
		mutate,
	} = useMutation<INetworkElementsSubscribeDTO>({
		mutationKey: [NETWORK_ELEMENTS_SUBSCRIBE],
		mutationFn: subscribeNetworkElement,
		onSuccess: (data: INetworkElement) => {
			const { name, subscription } = data;

			handleCloseModal();

			dispatch(setSnackbar({
				message: subscription ? subscribeNetworkElementMessage(name) : unsubscribeNetworkElement(name),
				type: ESnackbarTypes.success,
			}));

			return invalidateNetworkElements();
		},
	});

	return {
		subscribeNetworkElement: mutate,
		isLoadingSubscribeNetworkElement: isLoading,
	};
};

export default useMutateNetworkElementsSubscribe;
